export type EnemyId = 'pop' | 'krasue' | 'tanee' | 'mae-tanee' | 'krahang' | 'violent-dead';

export type EnemyDefinition = {
  id: EnemyId;
  nameTh: string;
  maxHp: number;
  moveSpeed: number;
  attackRange: number;
  damage: number;
  telegraphMs: number;
  attackCadenceMs: number;
  scale: number;
  boss: boolean;
  movement: 'ground-chase' | 'hover-chase' | 'stalk' | 'boss-stalk';
};

export const ENEMIES: Record<EnemyId, EnemyDefinition> = {
  krahang: {id:'krahang',nameTh:'กระหัง',maxHp:210,moveSpeed:96,attackRange:145,damage:16,telegraphMs:760,attackCadenceMs:1850,scale:1.05,boss:false,movement:'hover-chase'},
  'violent-dead': {id:'violent-dead',nameTh:'ผีตายโหง',maxHp:260,moveSpeed:66,attackRange:160,damage:20,telegraphMs:920,attackCadenceMs:2200,scale:1,boss:false,movement:'stalk'},
  pop: { id: 'pop', nameTh: 'ปอบ', maxHp: 180, moveSpeed: 72, attackRange: 128, damage: 14, telegraphMs: 680, attackCadenceMs: 1750, scale: 1, boss: false, movement: 'ground-chase' },
  krasue: { id: 'krasue', nameTh: 'กระสือ', maxHp: 135, moveSpeed: 108, attackRange: 172, damage: 11, telegraphMs: 520, attackCadenceMs: 1450, scale: 0.94, boss: false, movement: 'hover-chase' },
  tanee: { id: 'tanee', nameTh: 'ตานี', maxHp: 230, moveSpeed: 54, attackRange: 208, damage: 18, telegraphMs: 820, attackCadenceMs: 2100, scale: 1.08, boss: false, movement: 'stalk' },
  'mae-tanee': { id: 'mae-tanee', nameTh: 'แม่ตานีพันปี', maxHp: 1200, moveSpeed: 42, attackRange: 258, damage: 28, telegraphMs: 1250, attackCadenceMs: 2600, scale: 1.34, boss: true, movement: 'boss-stalk' },
};

export const NORMAL_ENEMY_IDS: EnemyId[] = ['pop', 'krasue', 'tanee'];

export function enemyRenderScale(def: EnemyDefinition, viewportHeight: number): number {
  if (viewportHeight >= 560) return def.scale;
  return def.scale * (def.boss ? 0.43 : 0.72);
}

export function enemyFacingScale(renderScale: number, direction: number): number {
  return Math.abs(renderScale) * (direction < 0 ? -1 : 1);
}

export function enemyStrikeReady(def: EnemyDefinition, telegraphStartedAt: number, now: number): boolean {
  return now - telegraphStartedAt >= def.telegraphMs;
}

export function enemyDefinition(id: string | null | undefined): EnemyDefinition {
  if (id && id in ENEMIES) return ENEMIES[id as EnemyId];
  return ENEMIES.pop;
}
